/**
 * 网络数据请求
 */
import qs from "qs";
import axios from "axios";
// const baseURL = "https://agriculture.sgsugou.com"//测试

// const baseURL = 'http://localhost:8081'
// const baseURL = "https://agriculture-api.wyouquan.cn";
const baseURL = "https://agriculture-pc-api.wyouquan.cn";//正式
axios.defaults.timeout = 300000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.baseURL = baseURL;


/**
 * 网络数据请求
 * @param {*} url
 * @param {*} params
 * @param {*} successCallback
 * @param {*} errCallback
 * @param {*} me  调用接口的this.用于发现登录过期后，跳到登录界面的
 * @param {*} loading  如果主界面有正在加载的话，要关掉
 */

function postAction(url, params, successCallback, errCallback, me, loading) {
  // 将token赋上
  let xfh_token = localStorage.getItem("xfh_usertoken");
  if (!params) {
    params = {};
  }
  if (!xfh_token) {
    xfh_token = "";
  }
  params.token = xfh_token;
  params.time = new Date().getTime()
  axios
    .post(url, params)
    .then(function (response) {
      if (
        response.data &&
        response.data.returnCode &&
        response.data.returnCode == "NOLOGIN"
      ) {
        if (loading) {
          loading.close();
        }
        if (me) {
          me.$router.push("/login");
          return;
        }
      }
      successCallback(response.data);
    })
    .catch(function (response) {
      errCallback(response.data);
    });
}
function doPost(url, params, successCallback, errCallback, me, loading) {
  // 将token赋上
  let xfh_token = localStorage.getItem("xfh_usertoken");
  if (!params) {
    params = {};
  }
  if (!xfh_token) {
    xfh_token = "";
  }
  params.token = xfh_token;
  params.time = new Date().getTime()
  axios
    .post(url, qs.stringify(params))
    .then(function (response) {
      if (
        response.data &&
        response.data.returnCode &&
        response.data.returnCode == "NOLOGIN"
      ) {
        if (loading) {
          loading.close();
        }
        if (me) {
          me.$router.push("/login");
          return;
        }
      }
      successCallback(response.data);
    })
    .catch(function (response) {
      errCallback(response.data);
    });
}
/**
 * 网络数据请求
 * @param {*} url
 * @param {*} params
 * @param {*} successCallback
 * @param {*} errCallback
 * @param {*} me  调用接口的this.用于发现登录过期后，跳到登录界面的
 * @param {*} loading  如果主界面有正在加载的话，要关掉
 */
function doGet(url, params, successCallback, errCallback, me, loading) {
  // 将token赋上
  let xfh_token = localStorage.getItem("xfh_usertoken");
  if (!params) {
    params = {};
  }
  if (!xfh_token) {
    xfh_token = "";
  }
  params.token = xfh_token;
  url += "?" + qs.stringify(params) + '&time=' + new Date().getTime()
  axios
    .get(url)
    .then(function (response) {
      if (
        response.data &&
        response.data.returnCode &&
        response.data.returnCode == "NOLOGIN"
      ) {
        if (loading) {
          loading.close();
        }
        if (me) {
          me.$router.push("/login");
          return;
        }
      }
      successCallback(response.data);
    })
    .catch(function (response) {
      errCallback(response.data);
    });
}
function doGetBlob(url, params, successCallback, errCallback, me, loading) {
  // 将token赋上
  let xfh_token = localStorage.getItem("xfh_usertoken");
  if (!params) {
    params = {};
  }
  if (!xfh_token) {
    xfh_token = "";
  }
  params.token = xfh_token;
  url += "?" + qs.stringify(params) + '&time=' + new Date().getTime()
  axios
    .get(url, { responseType: 'blob' })
    .then(function (response) {
      if (
        response.data &&
        response.data.returnCode &&
        response.data.returnCode == "NOLOGIN"
      ) {
        if (loading) {
          loading.close();
        }
        if (me) {
          me.$router.push("/login");
          return;
        }
      }
      successCallback(response.data);
    })
    .catch(function (response) {
      errCallback(response.data);
    });
}
/**
 * 上传图片
 * @param {*} url
 * @param {*} params
 * @param {*} successCallback
 * @param {*} errCallback
 */
function postImg(url, params, successCallback, errCallback) {
  // 添加请求头
  let config = {
    headers: { "Content-Type": "multipart/form-data" }
  };
  // 将token赋上
  let xfh_token = localStorage.getItem("xfh_usertoken");
  if (!xfh_token) {
    xfh_token = "";
  }
  params.append("xfh_token", xfh_token);
  params.append('time', new Date().getTime())
  axios
    .post(url, params, config)
    .then(function (response) {
      if (
        response.data &&
        response.data.returnCode &&
        response.data.returnCode == "NOLOGIN"
      ) {
        if (loading) {
          loading.close();
        }
        if (me) {
          me.$router.push("/login");
          return;
        }
      }
      successCallback(response.data);
    })
    .catch(function (response) {
      errCallback(response.data);
    });
}

export { doPost, doGet, doGetBlob, postImg, postAction, baseURL };



// WEBPACK FOOTER //
// ./src/components/common/HttpHelper.js